import axios from 'axios';
import Service from '@advisor/util/Service';

const {MS_BASE} = Service;

export default class Household {
  static getDefaultParam(riaUserId) {
    return `riaUserId=${riaUserId}`;
  }

  /** ***************************** Household Api start ***************************************************************** */
  /**
   * This will fetch houseHold information based on houseHoldId
   * @param {houseHoldId} payload
   */
  static getHouseHoldInfo({householdId, riaUserId}) {
    return axios.get(`${MS_BASE}/v1/client/houseHold/${householdId}?${Household.getDefaultParam(riaUserId)}`);
  }

  /**
   * This will fetch houseHold goals as well as Client goals based on houseHoldId and accountList related to Goal
   * @param {householdId} payload
   */
  static getSummaryGoalList({householdId, riaUserId}) {
    return axios.get(`${MS_BASE}/v1/client/houseHold/${householdId}/allGoals?${Household.getDefaultParam(riaUserId)}`);
  }

  /**
   * This will remove client from Household, related accounts are also unattached from household.
   * @param {clientId, householdId} payload
   */
  static deleteClient({householdId, clientId, riaUserId}) {
    return axios.delete(
      `${MS_BASE}/v1/client/household/${householdId}/clUser/${clientId}?${Household.getDefaultParam(riaUserId)}`
    );
  }

  /**
   * This will add household goal in Household.
   * @param {householdId} payload
   */
  static addHouseholdGoal(payload) {
    return axios.post(
      `${MS_BASE}/v1/client/household/${payload.householdId}/goal?${Household.getDefaultParam(payload.riaUserId)}`,
      payload
    );
  }

  static updateHouseholdGoal(payload) {
    return axios.put(
      `${MS_BASE}/v1/client/household/${payload.householdId}/goal/${payload.goalId}?${Household.getDefaultParam(
        payload.riaUserId
      )}`,
      payload
    );
  }

  /** This will fetch accounts that are associated with household.
   * @param {householdId} payload
   */
  static fetchHHAccounts({householdId, riaUserId}) {
    return axios.get(`${MS_BASE}/v1/client/household/${householdId}/accounts?${Household.getDefaultParam(riaUserId)}`);
  }

  /** This will remove household,also remove all goals and accounts attached to that household
   * @param {HouseholdId} payload
   */
  static deleteHousehold({householdId, riaUserId}) {
    return axios.delete(`${MS_BASE}/v1/client/household/${householdId}?${Household.getDefaultParam(riaUserId)}`);
  }

  /** This will fetch unassigned accounts of all members of household
   * @param {householdId} payload Should contain householdId
   */
  static getUnassignedAccounts({householdId, riaUserId}) {
    return axios.get(
      `${MS_BASE}/v1/client/household/${householdId}/unAssignedAccount?${Household.getDefaultParam(riaUserId)}`
    );
  }

  /** This will fetch household goals of household, it will be dsiplayed in dropdown for unassigned accounts.
   * @param {householdId} payload Should contain householdId
   */
  static getHouseholdGoals({householdId, riaUserId}) {
    return axios.get(`${MS_BASE}/v1/client/household/${householdId}/goals?${Household.getDefaultParam(riaUserId)}`);
  }

  /**
   * This will fetch all clients and respectives accounts for household , it will used in listing for add/edit Household and assign client
   */
  static getClientAccounts({riaUserId, offset, limit, orderBy, searchValue, excludedAccounts, excludedClUsers}) {
    return axios.get(
      `${MS_BASE}/v1/client/household/clientAccounts?riaUserId=${riaUserId}&limit=${limit}&offset=${offset}&orderBy=${orderBy}&searchValue=${searchValue}&excludeAccounts=${excludedAccounts}&excludeClUsers=${excludedClUsers}`
    );
  }

  /**
   * This will update household details such as household name, members and its accounts
   */
  static updateHousehold(payload) {
    return axios.put(
      `${MS_BASE}/v1/client/household/${payload.householdId}?${Household.getDefaultParam(payload.riaUserId)}`,
      payload
    );
  }

  /**
   * This will add new household in ria
   */
  static addHousehold(payload) {
    return axios.post(`${MS_BASE}/v1/client/household?${Household.getDefaultParam(payload.riaUserId)}`, payload);
  }

  /**
   * This will get household accounts which are associated with hh goals
   */
  static getHouseholdGoalAccounts({riaUserId, householdId, goalId}) {
    return axios.get(
      `${MS_BASE}/v1/client/household/${householdId}/goal/${goalId}?${Household.getDefaultParam(riaUserId)}`
    );
  }

  /**
   * This will get household summary information
   */
  static getHouseholdGoalDetail({goalId}) {
    return axios.get(`${MS_BASE}/v1/client/goals/${goalId}`);
  }
}
